// extracted by mini-css-extract-plugin
export var leftAlign = "_35-2";
export var popper = "_35-0";
export var subtitle = "_35-1";